module.exports = "./img/a680281786a0e578df50582d1178b4b0.png";